import { rem } from "polished";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  CardContainer,
  StyledSponsorCard,
} from "@/components/editor/themes/crosby/blocks/sponsors/sponsor-card/sponsor-card-component-styles";

const numOfColsToMaxHeight = {
  3: rem(224),
  4: rem(179),
  6: rem(105),
  mobile: {
    3: rem(196),
    4: rem(213),
    6: rem(93),
  },
};

const numOfColsToImgHeight = {
  3: rem(144),
  4: rem(99),
  6: rem(57),
};

const numOfColsToMaxWidth = {
  3: rem(392),
  4: rem(288),
  6: rem(184),
  mobile: {
    3: rem(343),
    4: rem(343),
    6: rem(164),
  },
};

export const StyledList = withViewportStyle("div")<{ numOfCols: number }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${StyledSponsorCard} {
    max-width: ${({ numOfCols }) => numOfColsToMaxWidth[numOfCols]};
    max-height: ${({ numOfCols }) => numOfColsToMaxHeight[numOfCols]};
  }

  ${CardContainer} {
    padding: ${({ numOfCols }) => (numOfCols === 6 ? rem(8) : rem(24))};
  }

  ${({ $viewport }) => $viewport.mobile`
    ${StyledSponsorCard} {
      max-width: ${({ numOfCols }) => numOfColsToMaxWidth.mobile[numOfCols]};
      height: ${({ numOfCols }) => numOfColsToMaxHeight.mobile[numOfCols]};
    }
  `};

  img {
    height: ${({ numOfCols }) => numOfColsToImgHeight[numOfCols]};
  }
`;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${({ $viewport }) => $viewport.mobile`
    padding: ${rem(64)} ${rem(16)} ${rem(50)};
  `};
`;
